// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lVyi","expireSoon":"styles_expireSoon__hSRoS"};